<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true" *ngIf="meal">{{ meal.title }}</div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-search" (click)="toggleSearch()"></i>
            <i class="ti-filter" (click)="openFilter($event)"></i>
            <div class="chat-spinner" (click)="openFilter($event)">
                <div class="big-spinner"></div>
                <div class="big-spinner-outer"></div>
            </div>
            <i class="ti-close" (click)="bsModalRef.hide()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <div
                 [ngClass]="!showSearch ? 'hidden-search' : ''"
                 class="search-wrapper animated fadeInDown">
                <input #search type="text" [(ngModel)]="searchText"/>
                <div class="responsive-flex-wrapper">
                    <i class="fa fa-search"></i>
                </div>
                <div class="responsive-flex-wrapper" *ngIf="!search.value">{{ 'search' | localise }}</div>
            </div>
            <div class="recipe-categories btn-group" role="group">
                <button
                        *ngFor="let category of recipeCategories"
                        [ngClass]="category.id === selectedCategory ? 'active' : ''"
                        (click)="onChangeCategory(category.id)"
                        class="btn btn-outline-secondary">{{ category.title }}</button>
            </div>
            <div class="cards-wrapper"
                 [ngClass]="showSearch ? 'with-search' : ''"
                [ngStyle]="{'height': (loading ? '100%' : null), 'marginTop': (loading ? '-20px' : null)}"
            >
                <ng-container *ngIf="loading">
                    <div class="box-placeholder"
                         *ngFor="let i of [0,1,2,3,4,5,6]">
                        <span class="category text link line"></span>
                        <span class="clearfix"></span>
                        <span class="text nutrient"></span>
                        <span class="text nutrient"></span>
                        <span class="text nutrient"></span>
                        <span class="text nutrient last"></span>
                    </div>
                </ng-container>

                <ng-container *ngIf="!loading">
                    <div id="recipes-list" *ngIf="recipes.length">
                        <div *ngFor="let recipe of recipes | callback: filterRecipes:this; let i = index" class="card">
                            <div class="card-body" (click)="onViewRecipe($event, recipe, (isFreePlan && i > 3))">
                                <h5 class="recipe-title">
                                    <i *ngIf="(isFreePlan && i > 3)" class="recipe-lock fa fa-lock"></i>

                                    {{ recipe.recipe.title }}
                                </h5>

<!--                                <div-->
<!--                                        *ngIf="recipe.recipe.influencer"-->
<!--                                        class="star-name">-->
<!--                                    {{ 'dashboard_recipe_of' | localise }} <strong>{{ recipe.recipe.influencer.influencer.name }}</strong>-->
<!--                                </div>-->

                                <div
                                        (click)="onViewRecipe($event, recipe, (isFreePlan && i > 3))"
                                        *ngIf="recipe.recipe.images && recipe.recipe.images.length > 0"
                                        [lazyLoad]="constants.imagesUrl() + '/images/850x500/' + recipe.recipe.images[0].type + '/' + recipe.recipe.images[0].name"
                                        class="recipe-image animated fadeIn">

                                    <div *ngIf="recipe.recipe.price > 0" class="recipe-price">
                                        {{ recipe.recipe.price }}
                                        {{ 'currency' | localise }}
                                    </div>

<!--                                    <div class="star-image"-->
<!--                                         *ngIf="recipe.recipe.influencer && recipe.recipe.influencer.image"-->
<!--                                         [lazyLoad]="constants.imagesUrl() + '/images/600x350/' + recipe.recipe.influencer.image.type + '/' + recipe.recipe.influencer.image.name + '/'"-->
<!--                                    ></div>-->

                                    <div class="recipe-calories">
                                        <img [src]="getSvg('cal')"/>
                                        <span>
                                {{ floor(recipe.macros.calories) }}
                                            kcal
                            </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="!recipes.length">
                        <div class="responsive-flex-wrapper no-results-wrapper">{{ 'no_results_found' | localise }}</div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>
